interface TitleBarProps {
    title: string;
    isMaximized: boolean;
    onMouseDown: (e: React.MouseEvent) => void;
    onMinimize: () => void;
    onMaximize: () => void;
    onClose: () => void;
}

export const TitleBar = ({ title, isMaximized, onMouseDown, onMinimize, onMaximize, onClose }: TitleBarProps) => {
    return (
        <div className="h-9 bg-gray-800 text-white flex items-center px-3 cursor-move" onMouseDown={onMouseDown} onDoubleClick={onMaximize}>
            <div className="flex-1 text-sm font-medium truncate">{title}</div>
            <div className="flex">
                <button className="w-10 h-8 flex items-center justify-center hover:bg-gray-700" onClick={onMinimize}>
                    <span className="w-3 h-0.5 bg-white"></span>
                </button>
                <button className="w-10 h-8 flex items-center justify-center hover:bg-gray-700" onClick={onMaximize}>
                    <div className="w-3 h-3 border border-white"></div>
                </button>
                <button className="w-10 h-8 flex items-center justify-center hover:bg-red-600" onClick={onClose}>
                    <span className="w-3 h-0.5 bg-white rotate-45 absolute"></span>
                    <span className="w-3 h-0.5 bg-white -rotate-45 absolute"></span>
                </button>
            </div>
        </div>
    );
};
